var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('div',{staticClass:"alert alert-info text-center"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.msg))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }